import apiInstance from "../api";
import endPoints from "../endpoints";

export const post = (payload) => {
  return apiInstance().post(endPoints.mappingTemplates.post, payload, {
    headers: { "content-type": "multipart/form-data" },
  });
};
export const createRule = (payload) => {
  return apiInstance().post(endPoints.mappingTemplates.createRule, payload, {
    headers: { "content-type": "multipart/form-data" },
  });
};
export const createSettings = (payload) => {
  return apiInstance().post(
    endPoints.mappingTemplates.createSettings,
    payload,
    {
      headers: { "content-type": "multipart/form-data" },
    }
  );
};
export const generateOutputProfile = (payload) => {
  return apiInstance().post(
    endPoints.mappingTemplates.generateOutputProfile,
    payload,
    {
      headers: { "content-type": "multipart/form-data" },
    }
  );
};
